import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6f0f41da&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6f0f41da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0f41da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0f41da')) {
      api.createRecord('6f0f41da', component.options)
    } else {
      api.reload('6f0f41da', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6f0f41da&scoped=true&", function () {
      api.rerender('6f0f41da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n937v0qYSzQl/JS/comp/GuestBox.vue"
export default component.exports